import React, { useState, useEffect } from "react";
import LoadingSpinner from "../components/LoadingSpinner";
import { hasPermission } from "../helpers/permission";

const CampaignExportModal = ({
    isOpen,
    onClose,
    onSubmit,
    loading,
    checkingAll,
    selectedCount,
}) => {
    const [startLimit, setStartLimit] = useState("");
    const [endLimit, setEndLimit] = useState("");

    useEffect(() => {
        if (isOpen) {
            // Auto-fill limits when "checkingAll" is true
            if (checkingAll && selectedCount) {
                setStartLimit("1");
                setEndLimit(selectedCount.toString());
            } else {
                setStartLimit("");
                setEndLimit("");
            }
        } else {
            setStartLimit("");
            setEndLimit("");
        }
    }, [isOpen, checkingAll, selectedCount]);

    if (!isOpen) return null;
    if (loading) return <LoadingSpinner />;

    const handleSubmit = (e) => {
        e.preventDefault();

        if (startLimit && endLimit && parseInt(startLimit) > parseInt(endLimit)) {
            alert("Start Limit cannot be greater than End Limit");
            return;
        }

        onSubmit({
            startLimit: startLimit || undefined,
            endLimit: endLimit || undefined,
        });
    };

    // ✅ Calculate selected record count dynamically if start & end limits are valid
    const calculatedCount =
        startLimit && endLimit && parseInt(endLimit) >= parseInt(startLimit)
            ? parseInt(endLimit) - parseInt(startLimit) + 1
            : selectedCount;

    return (
        <>
            <div className="modal-backdrop fade show"></div>
            <div className="modal fade show" style={{ display: "block" }}>
                <div className="modal-dialog modal-md">
                    <div className="modal-content">
                        <div className="modal-header d-flex justify-content-between align-items-start">
                            <div>
                                {/* <h5 className="modal-title mb-0">
                                    Campaign Export{" "}
                                    <small className="text-muted">
                                        ({checkingAll
                                            ? `All ${calculatedCount}`
                                            : `${calculatedCount}`}{" "}
                                        records selected)
                                    </small>
                                </h5> */}
                                <h5 className="modal-title mb-0">
                                    Campaign Export{" "}
                                    <small className="text-muted">
                                        ({checkingAll
                                            ? `All ${selectedCount}`
                                            : `${selectedCount}`}{" "}
                                        records selected)
                                    </small>
                                </h5>
                            </div>
                            <button
                                type="button"
                                className="btn btn-close"
                                onClick={onClose}
                                aria-label="Close"
                            ></button>
                        </div>

                        <div className="modal-body">
                            <form onSubmit={handleSubmit}>
                                {/* Show limit fields only if checkingAll is true */}
                                {checkingAll && (
                                    <div className="row">
                                        <div className="mb-3 col-md-6">
                                            <label>Start Limit</label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                value={startLimit}
                                                onChange={(e) =>
                                                    setStartLimit(
                                                        e.target.value.replace(
                                                            /[^0-9]/g,
                                                            ""
                                                        )
                                                    )
                                                }
                                                placeholder="Start record number"
                                            />
                                        </div>

                                        <div className="mb-3 col-md-6">
                                            <label>End Limit</label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                value={endLimit}
                                                onChange={(e) =>
                                                    setEndLimit(
                                                        e.target.value.replace(
                                                            /[^0-9]/g,
                                                            ""
                                                        )
                                                    )
                                                }
                                                placeholder="End record number"
                                            />
                                        </div>

                                        {/* ✅ Display total selected records below the inputs */}
                                        <div className="col-12 mt-1">
                                            <strong>Total Records Selected: {calculatedCount}</strong>
                                        </div>
                                    </div>
                                )}

                                <div className="d-flex justify-content-end">
                                    {hasPermission("subscriber", "export") ? (
                                        <button
                                            type="submit"
                                            className="btn btn-primary me-2"
                                            disabled={loading}
                                        >
                                            {loading ? "Exporting..." : "Export"}
                                        </button>
                                    ) : (
                                        <button
                                            type="button"
                                            className="btn btn-primary me-2"
                                            disabled
                                        >
                                            Export
                                        </button>
                                    )}
                                    <button
                                        type="button"
                                        className="btn btn-secondary"
                                        onClick={onClose}
                                    >
                                        Cancel
                                    </button>
                                </div>
                            </form>

                            {/* ✅ Display total selected records at the bottom */}
                            {/* <div className="mt-3 text-end">
                                <strong>Total Records Selected: {calculatedCount}</strong>
                            </div> */}
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default CampaignExportModal;
